export enum FeatureFlag {
  INTERNAL = 'INTERNAL',
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}
